import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

export default function ChildHistory() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [child, setChild] = useState(null);
  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const fetchData = (id) => {
    const apiUrl = `${process.env.REACT_APP_MAIN_URL}/dashboard/edit_get_child/${id}`;
    setLoading(true);
    axios
      .get(apiUrl, axiosConfig)
      .then((response) => {
        setChild(response.data);
        setLoading(false);
      })
      .catch((error) => {
        toast.error("Something went wrong");
        setLoading(false);
      });
  };
  useEffect(() => {
    if (id) {
      fetchData(id);
    }
  }, [id]);
  return (
    <div className="mt-16">
      <div className="max-w-5xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden mt-4">
        <table className="min-w-full bg-white border border-gray-200 shadow-lg rounded-lg overflow-hidden">
          <thead className="bg-blue-500 text-white">
            <tr className="text-sm">
              <th className="px-4 py-2 text-left">Vaccination Number</th>
              <th className="px-4 py-2 text-left">Vaccination Name</th>
              <th className="px-4 py-2 text-left">Date</th>
            </tr>
          </thead>
          <tbody>
            {child?.history?.length > 0 ? (
              child.history.map((val, index) => (
                <tr key={index} className="text-left text-xs">
                  <td className="px-4 py-2 border-b border-gray-200">
                    {val?.vaccination_visi}
                  </td>
                  <td className="px-4 py-2 border-b border-gray-200">
                    {val?.type_of_vaccination}
                  </td>
                  <td className="px-4 py-2 border-b border-gray-200"></td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="px-4 py-2 text-center text-gray-500">
                  No data found
                </td>
              </tr>
            )}
            {/* Add more rows as needed */}
          </tbody>
        </table>
      </div>
    </div>
  );
}
